import React, {useMemo} from "react";
import {useTranslation} from "react-i18next";
import useChallengeModeTranslation from "../../../hooks/translation/useChallengeModeTransaltion";
import {useTour} from "../../../providers/tour";
import {reverse} from "../../../routing";
import {gql} from "@apollo/client";
import {isEditorIndexTourMock} from "../../../scenes/editor/index.tour";
import {Challenge} from "../../../schema";

import ReactLink from "../../ReactLink";
import Skeleton from "../../../ui/skeleton";

import cn from "classnames";
import classes from "./ChallengeTableItem.module.css";

type props = React.ComponentProps<typeof ReactLink> & {
  challenge: Pick<Challenge, "mode" | "name" | "id">;
};

export default function ChallengeTableItem({className, challenge, ...props}: props) {
  const {t} = useTranslation();

  const {mock: tourMock} = useTour();
  const mock = useMemo(() => {
    if (tourMock && isEditorIndexTourMock(tourMock)) {
      return tourMock.getBy.challenge.get(challenge.id);
    }
  }, [tourMock, challenge.id]);


  const mode = useChallengeModeTranslation(challenge.mode)

  return (
    <ReactLink
      className={cn(classes.root, mock?.classes.item, className)}
      title={challenge.name}
      href={mock?.href ?? reverse("editorChallengeEdit", {id: challenge.id})}
      {...props}
    >
      <span className={cn(classes.name, {[classes.notSpecified]: !!challenge.name})} translate="no">
        {challenge.name ?? t("common.notSpecified")}
      </span>
      <div className={classes.info}>
        <span className={classes.mode}>{mode}</span>
      </div>
    </ReactLink>
  );
}

ChallengeTableItem.Skeleton = React.memo(function ({
  className,
  ...props
}: React.ComponentProps<typeof Skeleton.Block>) {
  return <Skeleton.Block className={cn(classes.root, className)} height={60} {...props} />;
});

ChallengeTableItem.fragments = {
  root: gql`
    fragment ChallengeTableItem on Challenge {
      id
      name
      mode
    }
  `,
};
